import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { HitStatus } from './hit-status.interface';

export class HitStatusService {
   async getHitStatuss() {
      throw Error('Method not implemented');
   }

   async getHitStatus() {
      throw Error('Method not implemented');
   }

   async postHitStatus(hitId: number, hitStatus: HitStatus) {
      const response = await http.post<ApiResource<HitStatus>>(`hits/${hitId}/hit-statuses`, hitStatus);
      return response.data;
   }

   async putHitStatus(hitId: number, hitStatus: HitStatus) {
      const response = await http.put<ApiResource<HitStatus>>(`hits/${hitId}/hit-statuses/${hitStatus.id}`, hitStatus);
      return response.data;
   }

   async deleteHitStatus() {
      throw Error('Method not implemented');
   }
}
